document.addEventListener("DOMContentLoaded", () => {
    const searchTrigger = document.getElementById('modal-search-toggle');
    searchTrigger.addEventListener('click', openModalSearch);

    const searchClose = document.getElementById('modal-search-close');
    searchClose.addEventListener('click', closeModalSearch);

    function openModalSearch(){
        document.getElementById('modal-search').classList.add('open');
        document.body.classList.add('modal-search__active');
    }

    function closeModalSearch(){
        document.querySelector('.modal-search.open').classList.remove('open');
        document.body.classList.remove('modal-search__active');
    }
});